"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderedContentItem = void 0;
/**
 * Class representing the response from the [Content Rendering Service](https://docs.amplience.net/integration/contentrenderingservice.html?h=rendering%20service).
 * Rendered content is the output of converting the JSON body of a content item using a template.
 */
var RenderedContentItem = /** @class */ (function () {
    function RenderedContentItem() {
    }
    return RenderedContentItem;
}());
exports.RenderedContentItem = RenderedContentItem;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUmVuZGVyZWRDb250ZW50SXRlbS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvcmVuZGVyaW5nL21vZGVsL1JlbmRlcmVkQ29udGVudEl0ZW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBR0E7OztHQUdHO0FBQ0g7SUFBQTtJQWtCQSxDQUFDO0lBQUQsMEJBQUM7QUFBRCxDQUFDLEFBbEJELElBa0JDO0FBbEJZLGtEQUFtQiJ9